export default __webpack_public_path__ + "static/media/bannersweb_promo_diadelasmadres_coche_330x330.02a52e4e.jpg";